import React, { Component } from "react";
import { Table, Button, Modal, Form, Message, Grid, List } from "semantic-ui-react";
import InlineError from "../messages/InlineError";
import axios from "axios";
import moment from "moment";

export class PasswordConfigurationsTable extends Component 
{
    state = {
        isModalOpen: false,
        isModalLogOpen: false,
        formData: { ...this.props.passwordConfigurations },
        errors: {},
        isUpdated: false,
        logData: [],
        filterLog: [],
        styles: {
            listItem: {
                cursor: "pointer",
                padding: "5px"
            },
            divDetail: {
                borderBottom: "1px solid gray",
                padding: "5px"
            },
            columnScroll: {
                maxHeight: '300px',
                overflowY: 'auto'
            }
        }
    };

    componentDidMount = () => {
        axios.get('/api/passwordConfigurations/getLog')
        .then((resp) => this.setState({ logData: resp.data.resp }))
        .catch((err) => console.log('Ocurrió un error: ' + err));
    }

    handleEdit = () => this.setState({ isModalOpen: !this.state.isModalOpen });
    handleLog = () => this.setState({ isModalLogOpen: !this.state.isModalLogOpen  })

    handleUpdate = () => {
        
        const errors = this.validateFields();
        this.setState({ errors });

        if (Object.keys(errors).length === 0) {

            const token = localStorage.getItem('practitioner_token');
            const params = this.state.formData;
            params.token = token;

            axios
            .post('/api/passwordConfigurations/store', { data: params })
            .then((resp) => {
                if (resp.data.status) {
                    this.setState({
                        isModalOpen: false,
                        isUpdated: true
                    });
                }
            })
            .catch((err) => console.log("Ocurrió un error: " + err));
        }

    }

    handleChange = (e) => {
        this.setState({
           formData: { ...this.state.formData, [e.target.id]: +e.target.value } 
        });
    }

    showDetail = (id) => {
        const filter = this.state.logData.filter((elm) => elm.id === id)[0];
        filter && (this.setState({ filterLog: filter }));
    }

    validateFields = () => {

        const errors = {};
        const { formData } = this.state;

        if (formData.longitud_minima === 0) {
            errors.longitud_minima = "La longítud mínima de la contraseña es un campo obligatorio.";
        }
        
        if (formData.cantidad_letras === 0) {
            errors.cantidad_letras = "La cantidad de letras de la contraseña es un campo obligatorio.";
        }

        if (formData.cantidad_numeros === 0) {
            errors.cantidad_numeros = "La cantidad de números de la contraseña es un campo obligatorio.";
        }

        if (formData.cantidad_mayusculas === 0) {
            errors.cantidad_mayusculas = "La cantidad de mayúsculas de la contraseña es un campo obligatorio.";
        }

        if (formData.cantidad_minusculas === 0) {
            errors.cantidad_minusculas = "La cantidad de minúsculas de la contraseña es un campo obligatorio.";
        }

        if (formData.cantidad_caracteres_especiales === 0) {
            errors.cantidad_caracteres_especiales = "La cantidad de caracteres especiales de la contraseña es un campo obligatorio.";
        }

        if (formData.dias_vigencia === 0) {
            errors.dias_vigencia = "Los días de vigencia de la contraseña es un campo obligatorio.";
        }

        if (formData.cantidad_historial === 0) {
            errors.cantidad_historial = "La cantidad de historial de la contraseña es un campo obligatorio.";
        }

        if (formData.numero_intentos_fallidos === 0) {
            errors.numero_intentos_fallidos = "El número de intentos fallidos de la contraseña es un campo obligatorio.";
        }

        if (formData.duracion_enlace_temporal === 0) {
            errors.duracion_enlace_temporal = "La duración del enlace temporal para cambiar la contraseña es un campo obligatorio.";
        }

        return errors;

    }

    render() {
        
        const { errors, formData, isUpdated } = this.state;

        return (
            <>
                <Button
                    content="Ver log de cambios"
                    icon='eye'
                    color="blue"
                    floated='right'
                    style={{ marginBottom: "10px" }}
                    onClick={() => this.handleLog() }
                ></Button>

                <Table attached="bottom" striped>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell textAlign="center" colSpan="12">
                                CONFIGURACIÓN PARÁMETROS DE CONTRASEÑA SEGURA
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell>
                                Longitud mín.
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Cant. letras
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Cant. números
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Cant. mayúsculas
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Cant. minúsculas
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Cant. caracteres especiales
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Cant. historial
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Días vigencia
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Núm. intentos fallidos
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Tiempo enlace temp.
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Editar
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>{formData.longitud_minima}</Table.Cell>
                            <Table.Cell>{formData.cantidad_letras}</Table.Cell>
                            <Table.Cell>{formData.cantidad_numeros}</Table.Cell>
                            <Table.Cell>{formData.cantidad_mayusculas}</Table.Cell>
                            <Table.Cell>{formData.cantidad_minusculas}</Table.Cell>
                            <Table.Cell>{formData.cantidad_caracteres_especiales}</Table.Cell>
                            <Table.Cell>{formData.cantidad_historial}</Table.Cell>
                            <Table.Cell>{formData.dias_vigencia}</Table.Cell>
                            <Table.Cell>{formData.numero_intentos_fallidos}</Table.Cell>
                            <Table.Cell>{formData.duracion_enlace_temporal}</Table.Cell>
                            <Table.Cell>
                                <Button
                                    icon="edit"
                                    color="blue"
                                    title="Click para editar"
                                    onClick={() => this.handleEdit() }
                                ></Button>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>

                {isUpdated &&
                    <Message color={"blue"} >
                        <Message.Header>Configuración de contraseña</Message.Header>
                        <p>
                            La actualización de los parámetros de la contraseña ha sido exitosa.
                        </p>
                    </Message>
                }

                <Modal
                    open={this.state.isModalOpen}
                >

                    <Modal.Header>
                        Editar configuración de contraseña
                    </Modal.Header>

                    <Modal.Content>
                        <Form>
                            <Form.Group widths='equal'>

                                <Form.Field error={!!errors.longitud_minima}>
                                    <label>Longitud mínima</label>
                                    <input
                                        className=""
                                        type="number"
                                        placeholder="Longitud mín. contraseña"
                                        id="longitud_minima"
                                        onChange={this.handleChange}
                                        defaultValue={formData.longitud_minima}
                                        />
                                        {errors.longitud_minima && <InlineError text={errors.longitud_minima} />}
                                </Form.Field>

                                <Form.Field error={!!errors.cantidad_letras}>
                                    <label>Cantidad de letras</label>
                                    <input
                                        className=""
                                        type="number"
                                        placeholder="Cantidad de letras"
                                        id="cantidad_letras"
                                        onChange={this.handleChange}
                                        defaultValue={formData.cantidad_letras}
                                    />
                                    {errors.cantidad_letras && <InlineError text={errors.cantidad_letras} />}
                                </Form.Field>

                                <Form.Field error={!!errors.cantidad_numeros}>
                                    <label>Cantidad de números</label>
                                    <input
                                        className=""
                                        type="number"
                                        placeholder="Cantidad de números"
                                        id="cantidad_numeros"
                                        onChange={this.handleChange}
                                        defaultValue={formData.cantidad_numeros}
                                    />
                                    {errors.cantidad_numeros && <InlineError text={errors.cantidad_numeros} />}
                                </Form.Field>

                                <Form.Field error={!!errors.cantidad_mayusculas}>
                                    <label>Cantidad de mayúsculas</label>
                                    <input
                                        className=""
                                        type="number"
                                        placeholder="Cantidad de mayúsculas"
                                        id="cantidad_mayusculas"
                                        onChange={this.handleChange}
                                        defaultValue={formData.cantidad_mayusculas}
                                    />
                                    {errors.cantidad_mayusculas && <InlineError text={errors.cantidad_mayusculas} />}
                                </Form.Field>

                            </Form.Group>

                            <Form.Group widths='equal'>

                                <Form.Field error={!!errors.cantidad_minusculas}>
                                    <label>Cantidad de minúsculas</label>
                                    <input
                                        className=""
                                        type="number"
                                        placeholder="Cantidad de minúsculas"
                                        id="cantidad_minusculas"
                                        onChange={this.handleChange}
                                        defaultValue={formData.cantidad_minusculas}
                                    />
                                    {errors.cantidad_minusculas && <InlineError text={errors.cantidad_minusculas} />}
                                </Form.Field>

                                <Form.Field error={!!errors.cantidad_caracteres_especiales}>
                                    <label>Cantidad de caract. especiales</label>
                                    <input
                                        className=""
                                        type="number"
                                        placeholder="Cantidad de caracteres especiales"
                                        id="cantidad_caracteres_especiales"
                                        onChange={this.handleChange}
                                        defaultValue={formData.cantidad_caracteres_especiales}
                                    />
                                    {errors.cantidad_caracteres_especiales && <InlineError text={errors.cantidad_caracteres_especiales} />}
                                </Form.Field>

                                <Form.Field error={!!errors.dias_vigencia}>
                                    <label>Días de vigencia</label>
                                    <input
                                        className=""
                                        type="number"
                                        placeholder="Días de vigencia contraseña"
                                        id="dias_vigencia"
                                        onChange={this.handleChange}
                                        defaultValue={formData.dias_vigencia}
                                    />
                                    {errors.dias_vigencia && <InlineError text={errors.dias_vigencia} />}
                                </Form.Field>

                                <Form.Field error={!!errors.cantidad_historial}>
                                    <label>Cantidad del historial</label>
                                    <input
                                        className=""
                                        type="number"
                                        placeholder="Cantidad de historial"
                                        id="cantidad_historial"
                                        onChange={this.handleChange}
                                        defaultValue={formData.cantidad_historial}
                                    />
                                    {errors.cantidad_historial && <InlineError text={errors.cantidad_historial} />}
                                </Form.Field>


                            </Form.Group>

                            <Form.Group widths='equal'>   
                                
                                <Form.Field error={!!errors.numero_intentos_fallidos}>
                                    <label>Número de intentos fallidos</label>
                                    <input
                                        className=""
                                        type="number"
                                        placeholder="Cantidad intentos fallidos"
                                        id="numero_intentos_fallidos"
                                        onChange={this.handleChange}
                                        defaultValue={formData.numero_intentos_fallidos}
                                    />
                                    {errors.numero_intentos_fallidos && <InlineError text={errors.numero_intentos_fallidos} />}
                                </Form.Field>

                                <Form.Field error={!!errors.duracion_enlace_temporal}>
                                    <label>Duración enlace temporal (minutos)</label>
                                    <input
                                        className=""
                                        type="number"
                                        placeholder="Tiempo en minutos"
                                        id="duracion_enlace_temporal"
                                        onChange={this.handleChange}
                                        defaultValue={formData.duracion_enlace_temporal}
                                    />
                                    {errors.duracion_enlace_temporal && <InlineError text={errors.duracion_enlace_temporal} />}
                                </Form.Field>

                            </Form.Group>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <Button
                            content="Actualizar"
                            icon='checkmark'
                            color="blue"
                            onClick={() => this.handleUpdate()}
                        ></Button>
                        <Button
                            content="Cerrar"
                            icon='close'
                            color="gray"
                            onClick={() => this.handleEdit()}
                        ></Button>
                    </Modal.Actions>

                </Modal>

                <Modal
                    open={this.state.isModalLogOpen}
                >

                    <Modal.Header>
                        Log cambios de parámetros de contraseña
                    </Modal.Header>

                    <Modal.Content>
                        <Grid columns={2} divided>
                            <Grid.Row>
                                <Grid.Column style={this.state.styles.columnScroll}>
                                    {this.state.logData.length > 0 ?
                                        <List>
                                        {this.state.logData.map((item, index) => (
                                            <List.Item key={index} title={"Click para ver detalle..."} className="item-log" style={this.state.styles.listItem} onClick={() => this.showDetail(item.id)}>
                                                <List.Content>
                                                    <div style={this.state.styles.divDetail}>{index + 1}. <b>Usuario: </b>{item.usuario} - <b>Fecha: </b>{ moment(item.fecha).format("DD-MM-YYYY HH:mm:ss") }</div>
                                                </List.Content>
                                            </List.Item>
                                        ))}
                                        </List>
                                    : <div>No hay información para mostrar.</div>
                                    }
                                </Grid.Column>
                                {(this.state.filterLog.fecha && this.state.filterLog.valores_actuales && this.state.filterLog.valores_actualizados) && 
                                    <Grid.Column>
                                        <div>
                                            <span><b>Fecha:</b> {moment(this.state.filterLog.fecha).format("DD-MM-YYYY HH:mm:ss")}</span>
                                            <br></br><br></br>
                                            <span><b>Valores previos:</b></span>
                                            <div>{this.state.filterLog.valores_actuales || "N/A"}</div>
                                        </div><br></br>
                                        <div>
                                            <span><b>Valores actualizados:</b></span>
                                            <div>{this.state.filterLog.valores_actualizados || "N/A"}</div>
                                        </div>
                                    </Grid.Column>
                                }
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>

                    <Modal.Actions>
                        <Button
                            content="Cerrar"
                            icon='close'
                            color="gray"
                            onClick={() => this.handleLog()}
                        ></Button>
                    </Modal.Actions>

                </Modal>
            </>
        );
    }

}

export default PasswordConfigurationsTable;